// Notes: ~/comments/aos-threejs-poc/liveBodyRig_two_rigs_can_be_the_body.md

/** The mounted avatar's transform group, or null. The GLB rig wins when both exist. */
export function resolveAvatarTransformTarget(scope = typeof window !== 'undefined' ? window : globalThis) {
  for (const group of [scope?.__AVATAR_GROUP__, scope?.__OGS_AVATAR_ROOT__]) {
    if (group?.position && group?.rotation) return group
  }
  return null
}
